export default function formatYearFromTill (yearFrom, yearTill) {
    let formattedFromDate = "";
    let formattedTillDate = "";
    if(yearFrom){
        let dFrom = new Date(yearFrom)
        formattedFromDate = (dFrom instanceof Date && isFinite(dFrom)) ? `${("0"+(dFrom.getMonth()+1)).slice(-2)}/${dFrom.getFullYear()}` : '';
    }
    if(yearTill && yearTill !== 'S'){
        let dTill = new Date(yearTill)
        formattedTillDate = (dTill instanceof Date && isFinite(dTill)) ? `${("0"+(dTill.getMonth()+1)).slice(-2)}/${dTill.getFullYear()}` : '';
    }
    return `${formattedFromDate} - ${formattedTillDate}`;
}